export default "__VITE_ASSET__CcdhfzUu__"